import { render, staticRenderFns } from "./addResumeDialog.vue?vue&type=template&id=2472acdb"
import script from "./addResumeDialog.vue?vue&type=script&lang=js"
export * from "./addResumeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports